import { Loader2, Sparkles } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

/** Phone-only bottom bar repeating the main action while it's scrolled out of view. */
export function StickyActionBar({
  visible,
  meta,
  label,
  busy,
  onAction,
}: {
  visible: boolean;
  meta: string;
  label: string;
  busy: boolean;
  onAction: () => void;
}) {
  return (
    <div
      aria-hidden={!visible}
      className={cn(
        'fixed inset-x-0 bottom-0 z-40 border-t border-border bg-background/95 px-4 pb-[calc(env(safe-area-inset-bottom)+0.75rem)] pt-3 shadow-[0_-8px_24px_rgba(0,0,0,0.08)] backdrop-blur transition-transform duration-200 lg:hidden',
        visible ? 'visible translate-y-0' : 'pointer-events-none invisible translate-y-full shadow-none',
      )}
    >
      <div className="mx-auto flex max-w-xl items-center gap-3">
        <p className="min-w-0 flex-1 truncate text-xs text-muted-foreground">{meta}</p>
        <Button size="lg" className="shrink-0" disabled={busy} onClick={onAction} tabIndex={visible ? 0 : -1}>
          {busy ? <Loader2 className="size-4 animate-spin" aria-hidden="true" /> : <Sparkles className="size-4" aria-hidden="true" />}
          {label}
        </Button>
      </div>
    </div>
  );
}
